import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!/\S+@\S+\.\S+/.test(email)) {
            toast.error("Please enter a valid email.");
            return;
        }
        setBusy(true);
        try {
            await api.post("/newsletter", { email, source: "footer" });
            setDone(true);
            setEmail("");
            toast.success("Subscribed — cleaning tips coming your way.");
        } catch {
            toast.error("Couldn't subscribe. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="newsletter-signup" className="mt-6">
            <div className="uppercase tracking-[0.2em] text-[10px] text-gold font-semibold mb-3 flex items-center gap-2">
                <Mail className="w-3 h-3" /> Newsletter
            </div>
            {done ? (
                <p className="font-outfit text-sm text-cream/80" data-testid="newsletter-thanks">
                    Thanks — we&apos;ll be in touch with tips &amp; special offers.
                </p>
            ) : (
                <form onSubmit={submit} className="flex gap-2">
                    <input
                        data-testid="newsletter-email"
                        type="email"
                        required
                        placeholder="Your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="flex-1 bg-transparent border border-cream/30 px-3 py-2 font-outfit text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold"
                    />
                    <button
                        data-testid="newsletter-submit"
                        type="submit"
                        disabled={busy}
                        className="bg-gold text-navy px-4 py-2 font-outfit text-xs uppercase tracking-wider hover:bg-gold-light disabled:opacity-50 whitespace-nowrap"
                    >
                        {busy ? "…" : "Join"}
                    </button>
                </form>
            )}
        </div>
    );
}
